export class HLCAreaSeriesRenderer {
  constructor() {
    this._data = null;
    this._options = null;
  }

  draw(target, priceConverter) {
    target.useBitmapCoordinateSpace((scope) =>
      this._drawImpl(scope, priceConverter)
    );
  }

  update(data, options) {
    this._data = data;
    this._options = options;
  }

  _drawImpl(renderingScope, priceToCoordinate) {
    if (
      !this._data ||
      this._data.bars.length === 0 ||
      !this._data.visibleRange ||
      !this._options
    ) {
      return;
    }
    const options = this._options;
    const bars = this._data.bars.map((bar) => {
      return {
        x: bar.x * renderingScope.horizontalPixelRatio,
        high:
          priceToCoordinate(bar.originalData.high) *
          renderingScope.verticalPixelRatio,
        low:
          priceToCoordinate(bar.originalData.low) *
          renderingScope.verticalPixelRatio,
        close:
          priceToCoordinate(bar.originalData.close) *
          renderingScope.verticalPixelRatio,
      };
    });

    const ctx = renderingScope.context;
    ctx.beginPath();
    const lowLine = new Path2D();
    const highLine = new Path2D();
    const closeLine = new Path2D();
    const firstBar = bars[this._data.visibleRange.from];
    lowLine.moveTo(firstBar.x, firstBar.low);
    highLine.moveTo(firstBar.x, firstBar.high);
    for (
      let i = this._data.visibleRange.from + 1;
      i < this._data.visibleRange.to;
      i++
    ) {
      const bar = bars[i];
      lowLine.lineTo(bar.x, bar.low);
      highLine.lineTo(bar.x, bar.high);
    }

    const lastBar = bars[this._data.visibleRange.to - 1];
    closeLine.moveTo(lastBar.x, lastBar.close);
    for (
      let i = this._data.visibleRange.to - 2;
      i >= this._data.visibleRange.from;
      i--
    ) {
      const bar = bars[i];
      closeLine.lineTo(bar.x, bar.close);
    }

    const topArea = new Path2D(highLine);
    topArea.lineTo(lastBar.x, lastBar.close);
    topArea.addPath(closeLine);
    topArea.lineTo(firstBar.x, firstBar.high);
    topArea.closePath();
    ctx.fillStyle = options.areaTopColor;
    ctx.fill(topArea);

    const bottomArea = new Path2D(lowLine);
    bottomArea.lineTo(lastBar.x, lastBar.close);
    bottomArea.addPath(closeLine);
    bottomArea.lineTo(firstBar.x, firstBar.low);
    bottomArea.closePath();
    ctx.fillStyle = options.areaBottomColor;
    ctx.fill(bottomArea);

    ctx.lineJoin = "round";
    ctx.strokeStyle = options.lowLineColor;
    ctx.lineWidth = options.lowLineWidth * renderingScope.verticalPixelRatio;
    ctx.stroke(lowLine);
    ctx.strokeStyle = options.highLineColor;
    ctx.lineWidth = options.highLineWidth * renderingScope.verticalPixelRatio;
    ctx.stroke(highLine);
    ctx.strokeStyle = options.closeLineColor;
    ctx.lineWidth = options.closeLineWidth * renderingScope.verticalPixelRatio;
    ctx.stroke(closeLine);
  }
}
